module.exports = __webpack_public_path__ + "static/media/home3.42de1bd4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/home3.webp
// module id = 412
// module chunks = 0